<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.join_provider_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <!-- بيانات مقدم الخدمة -->
        <div class="row mb-4">
          <div class="col-12 mb-3">
            <h5 class="section-title">
              {{ $t("PLACEHOLDERS.provider_data") }}
            </h5>
          </div>

          <!-- صورة شخصية -->
          <div class="col-12 mb-3" v-if="data.avatar">
            <div
              class="preview-container d-flex flex-column align-items-center gap-3"
            >
              <p>{{ $t("PLACEHOLDERS.avatar") }}</p>
              <img
                v-if="!avatarLoadError"
                :src="data.avatar"
                alt="Avatar"
                @error="avatarLoadError = true"
                @click="openImagePreview(data.avatar)"
                style="
                  cursor: pointer;
                  width: 150px;
                  height: 150px;
                  border-radius: 50%;
                  object-fit: cover;
                "
              />
              <div
                v-else
                style="
                  width: 200px;
                  height: 200px;
                  background-color: #f5f5f5;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0 auto;
                  border-radius: 4px;
                "
              >
                <i
                  class="fas fa-image"
                  style="font-size: 48px; color: #ccc"
                ></i>
              </div>
            </div>
          </div>

          <!-- اسم مقدم الخدمة -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.name"
            disabled
          />

          <!-- رقم الجوال -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_mobile')"
            v-model.trim="data.mobile"
            disabled
          />

          <!-- البريد الالكتروني -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
        </div>

        <!-- بيانات المستودع/الشركة اللوجستية/الفرد -->
        <div class="row">
          <div class="col-12 mb-3">
            <h5 class="section-title">
              {{ $t("PLACEHOLDERS.warehouse_company_data") }}
            </h5>
          </div>

          <!-- نوع النشاط -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.activity_type')"
            v-model.trim="data.activity_type_label"
            disabled
          />

          <!-- عنوان المخزن -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.warehouse_address')"
            v-model.trim="data.warehouse_address"
            disabled
          />

          <!-- العنوان -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            disabled
          />

          <!-- الخريطة -->
          <div class="col-12 mb-3" v-if="data.lat && data.lng">
            <h6 class="mb-2">{{ $t("PLACEHOLDERS.map_location") }}</h6>
            <MapComponent :lat="data.lat" :lng="data.lng" />
          </div>

          <!-- صورة السجل التجاري -->
          <div
            class="col-md-6 col-12 mb-3"
            v-if="
              data.commercial_registration_image &&
              data.activity_type !== 'individual'
            "
          >
            <div
              class="d-flex flex-column align-items-center justify-content-center p-3"
              style="
                border: 1px dashed #ef3405;
                border-radius: 8px;
                background: #fff5f2;
                height: 100%;
              "
            >
              <h6 class="mb-3 font-weight-bold" style="color: #ef3405">
                {{ $t("PLACEHOLDERS.commercial_register_image") }}
              </h6>
              <div
                v-if="!commercialRegLoadError"
                class="image-hover-zoom"
                style="overflow: hidden; border-radius: 8px; cursor: pointer"
                @click="openImagePreview(data.commercial_registration_image)"
              >
                <img
                  :src="data.commercial_registration_image"
                  alt="Commercial Registration"
                  @error="commercialRegLoadError = true"
                  style="
                    width: 100%;
                    max-width: 350px;
                    height: 180px;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                  "
                  onmouseover="this.style.transform='scale(1.05)'"
                  onmouseout="this.style.transform='scale(1)'"
                />
              </div>
              <div
                v-else
                style="
                  width: 200px;
                  height: 200px;
                  background-color: #f5f5f5;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0 auto;
                  border-radius: 4px;
                "
              >
                <i
                  class="fas fa-image"
                  style="font-size: 48px; color: #ccc"
                ></i>
              </div>
            </div>
          </div>

          <!-- صورة التسجيل الضريبي -->
          <div
            class="col-md-6 col-12 mb-3"
            v-if="
              data.tax_registration_image && data.activity_type !== 'individual'
            "
          >
            <div
              class="d-flex flex-column align-items-center justify-content-center p-3"
              style="
                border: 1px dashed #ef3405;
                border-radius: 8px;
                background: #fff5f2;
                height: 100%;
              "
            >
              <h6 class="mb-3 font-weight-bold" style="color: #ef3405">
                {{ $t("PLACEHOLDERS.tax_registration_image") }}
              </h6>
              <div
                v-if="!taxRegLoadError"
                class="image-hover-zoom"
                style="overflow: hidden; border-radius: 8px; cursor: pointer"
                @click="openImagePreview(data.tax_registration_image)"
              >
                <img
                  :src="data.tax_registration_image"
                  alt="Tax Registration"
                  @error="taxRegLoadError = true"
                  style="
                    width: 100%;
                    max-width: 350px;
                    height: 180px;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                  "
                  onmouseover="this.style.transform='scale(1.05)'"
                  onmouseout="this.style.transform='scale(1)'"
                />
              </div>
              <div
                v-else
                style="
                  width: 200px;
                  height: 200px;
                  background-color: #f5f5f5;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0 auto;
                  border-radius: 4px;
                "
              >
                <i
                  class="fas fa-image"
                  style="font-size: 48px; color: #ccc"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Image Preview Modal -->
    <v-dialog v-model="imagePreviewDialog" max-width="800">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ $t("PLACEHOLDERS.imagePreview") }}</span>
          <v-btn icon @click="imagePreviewDialog = false">
            <i class="fas fa-times"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <img
            :src="previewImageUrl"
            alt="Preview"
            style="width: 100%; max-height: 70vh; object-fit: contain"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import MapComponent from "../../../components/general/MapComponent.vue";

export default {
  name: "ShowJoinProvider",
  components: {
    UploadsPhotos,
    MapComponent,
  },
  data() {
    return {
      // Start:: Data Collection
      data: {
        name: null,
        avatar: null,
        mobile: null,
        email: null,
        activity_type: null,
        activity_type_label: null,
        warehouse_address: null,
        address: null,
        lat: null,
        lng: null,
        commercial_registration_image: null,
        tax_registration_image: null,
      },

      // Image Preview
      imagePreviewDialog: false,
      previewImageUrl: null,

      // Image Load Errors
      avatarLoadError: false,
      commercialRegLoadError: false,
      taxRegLoadError: false,
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Open Image Preview
    openImagePreview(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.imagePreviewDialog = true;
    },
    // End:: Open Image Preview

    // Start:: Get Activity Type Label
    getActivityTypeLabel(type) {
      const types = {
        logistics_company: this.$t("PLACEHOLDERS.logistics_company"),
        online_store: this.$t("PLACEHOLDERS.online_store"),
        traditional_store: this.$t("PLACEHOLDERS.traditional_store"),
        individual: this.$t("PLACEHOLDERS.individual"),
      };
      return types[type] || type;
    },
    // End:: Get Activity Type Label

    // Start:: Get Data To Display
    async getDataToEdit() {
      // Reset image load errors
      this.avatarLoadError = false;
      this.commercialRegLoadError = false;
      this.taxRegLoadError = false;

      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });

        const provider = res.data.data;
        const providerInfo = provider.provider_info;

        // Set Provider Data
        this.data.name = provider.name;
        this.data.avatar = provider.avatar?.url || null;
        this.data.mobile = provider.mobile;
        this.data.email = provider.email;

        // Set Warehouse/Company Data
        if (providerInfo) {
          this.data.activity_type = providerInfo.type;
          this.data.activity_type_label = this.getActivityTypeLabel(
            providerInfo.type
          );
          this.data.warehouse_address = providerInfo.warehouse_address;
          this.data.address = providerInfo.address;
          this.data.lat = parseFloat(providerInfo.lat);
          this.data.lng = parseFloat(providerInfo.lng);
          this.data.commercial_registration_image =
            providerInfo.commercial_registration_image?.url || null;
          this.data.tax_registration_image =
            providerInfo.tax_registration_image?.url || null;
        }
      } catch (error) {
        console.log(error.response.data.message);
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Get Data To Display
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}

.section-title {
  color: #ef3405;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 2px solid #ef3405;
  margin-bottom: 15px;
}

.success_btn {
  background-color: #28a745 !important;
  color: white !important;
}

.danger_btn {
  background-color: #dc3545 !important;
  color: white !important;
}
</style>
